module.exports = __webpack_public_path__ + "img/logo.dc357a72.svg";